"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessConceptsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.BusinessConceptsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.business_concepts.label',
    fallbackLabel: 'Store business concepts',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'TRADITIONAL_SALE_OF_GOODS', label: 'fields.enm.business_concepts.options.TRADITIONAL_SALE_OF_GOODS', fallbackLabel: 'Traditional sale of goods' },
        { key: 'VOUCHER', label: 'fields.enm.business_concepts.options.VOUCHER', fallbackLabel: 'Voucher' },
        { key: 'MEMBERSHIP', label: 'fields.enm.business_concepts.options.MEMBERSHIP', fallbackLabel: 'Membership' },
        { key: 'SUBSCRIPTION', label: 'fields.enm.business_concepts.options.SUBSCRIPTION', fallbackLabel: 'Subscription' },
        { key: 'PHARMACIES', label: 'fields.enm.business_concepts.options.PHARMACIES', fallbackLabel: 'Pharmacies' },
        { key: 'US_PHARMACIES', label: 'fields.enm.business_concepts.options.US_PHARMACIES', fallbackLabel: 'US Pharmacies' },
        { key: 'MEDICAL_SERVICES', label: 'fields.enm.business_concepts.options.MEDICAL_SERVICES', fallbackLabel: 'Medical Services' },
        { key: 'MARKETPLACES', label: 'fields.enm.business_concepts.options.MARKETPLACES', fallbackLabel: 'Marketplaces' },
        { key: 'FIREARM_DEALERS', label: 'fields.enm.business_concepts.options.FIREARM_DEALERS', fallbackLabel: 'Firearm dealers' },
        { key: 'AUCTIONS', label: 'fields.enm.business_concepts.options.AUCTIONS', fallbackLabel: 'Auctions' },
        { key: 'ALCOHOL', label: 'fields.enm.business_concepts.options.ALCOHOL', fallbackLabel: 'Alcohol' },
        { key: 'TOBACCO', label: 'fields.enm.business_concepts.options.TOBACCO', fallbackLabel: 'Tobacco' },
        { key: 'HEMP_CBD_THC', label: 'fields.enm.business_concepts.options.HEMP_CBD_THC', fallbackLabel: 'HEPM/CBD/THC' },
        { key: 'DONATIONS_CHARITY', label: 'fields.enm.business_concepts.options.DONATIONS_CHARITY', fallbackLabel: 'Donations charity' },
        { key: 'TRAVEL', label: 'fields.enm.business_concepts.options.TRAVEL', fallbackLabel: 'Travel' },
        { key: 'EVENTS', label: 'fields.enm.business_concepts.options.EVENTS', fallbackLabel: 'Events' },
        { key: 'COURSES', label: 'fields.enm.business_concepts.options.COURSES', fallbackLabel: 'Courses' },
    ],
    trackFieldValueWithAnalytics: false,
};
